<template>
  <div>
    <vxe-form
        ref="xForm"
        class="my-form2"
        title-align="right"
        title-width="120"
        :data="formData"
        :rules="formRules"
        @submit="submitEvent"
        @reset="cancelEvent"
    >
      <vxe-form-item title="结算账户" field="bindAccName" span="24">
        <template>
          <vxe-pulldown ref="accDown" transfer>
            <template v-slot>
              <div class="sel-link-text" @click="focusEvent()" target="_black" style="
                      cursor: pointer;
                      display: inline-block;
                      width: 100%;
                      text-algin: center;
                    ">
                {{formData.bindAccName ? formData.bindAccName : "请选择结算账户"}}
                <i class="vxe-input--suffix-icon fa vxe-icon--arrow-bottom"></i>
              </div>
            </template>
            <template v-slot:dropdown>
              <div class="company-dropdown4">
                <vxe-grid
                    highlight-hover-row
                    auto-resize
                    height="auto"
                    :loading="loading"
                    :data="accTableData"
                    :columns="accTableColumn"
                    empty-text="没有更多数据了！"
                    @cell-click="accCellClickEvent"
                >
                  <template v-slot:empty>
                        <span style="color: #2d8cf0;">
                          <p>请先添加银行账户</p>
                        </span>
                  </template>
                </vxe-grid>
              </div>
            </template>
          </vxe-pulldown>
        </template>
      </vxe-form-item>
      <vxe-form-item title="结算银行账号" field="bindAccNum" span="24">
        <template v-slot="scope">
          <vxe-input
              v-model="formData.bindAccNum"
              placeholder="请选择结算账户"
              disabled
              @input="$refs.xForm.updateStatus(scope)"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item
          title="结算开户银行"
          field="bindOpenBankName"
          span="24"
      >
        <template v-slot="scope">
          <vxe-input v-model="formData.bindOpenBankName" placeholder="请选择结算账户" disabled
                     @input="$refs.xForm.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item align="center" span="24">
        <template v-slot>
          <vxe-button type="submit" status="primary">确定</vxe-button>
          <vxe-button type="reset">取消</vxe-button>
        </template>
      </vxe-form-item>
    </vxe-form>
  </div>
</template>
<script>
  import $api from "@/apiProvider";
  import {showLoading, hideLoading, isNotEmpty, isEmpty} from "@/utils/util";

  export default {
    data() {
      return {
        memInfo: {},
        formData: {
          bindAccName: null, // 结算账户
          bindAccNum: null, // 结算银行账号
          bindOpenBankName: null, // 结算开户银行
        },
        loading: false,
        formRules: {
          bindAccName: [{required: true, message: "请选择结算账户"}],
          bindAccNum: [{required: true, message: "请输入银行账号"}],
          bindOpenBankName: [{required: true, message: "请输入结算开户银行"}],
        },
        accTableData: [],
        accTableColumn: [
          {field: "accountNum", title: "账户号"},
          {field: "openBankName", title: "开户行"},
        ],
      }
    },
    methods: {
      init(memInfo) {
        this.memInfo = memInfo
      },
      focusEvent() {
        this.$refs.accDown.showPanel();
        this.getPlatformCorp();
        this.$refs.xForm.clearValidate("bindAccName");
      },
      async getPlatformCorp() {
        console.log(this.memInfo)
        if (isEmpty(this.memInfo.memNum)) {
          this.$message.error("会员信息错误,请重新进入")
          return
        }
        if ( parseInt( this.memInfo.subjectType) === 0) {
          let res = await $api.platformCorp.post("getPlatformCompanyList", {
            accountName: this.memInfo.busiSubjectName,
          });
          this.accTableData = res.data.rows;
        }else{
          let res = await $api.baseUserSignBank.request("queryUserBankList", {
            userId: this.memInfo.subjectId,
            accountName: this.memInfo.memName
          });
          this.accTableData = res.data;
        }
      },
      accCellClickEvent({row}) {
        this.formData.bindAccName = row.accountName;
        this.formData.bindAccNum = row.accountNum;
        this.formData.bindOpenBankName = row.openBankName;
        this.formData.bindOpenOrgNum = row.openOrgNum;
        this.$refs.accDown.hidePanel();
      },
      async submitEvent() {
        showLoading();
        let obj = Object.assign({}, this.formData);
        obj.subAcc = this.memInfo.subAcc;
        obj.opeAccType = 0;
        let res = await $api.finance.request("bindAcc/bindAcc", obj);
        hideLoading();
        if (res.status === 1) {
          this.$Message.success("绑定成功");
          this.cancelEvent();
          this.$emit('afterSave')
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      cancelEvent() {
        this.formData = {
          bindAccName: null, // 结算账户
          bindAccNum: null, // 结算银行账号
          bindOpenBankName: null, // 结算开户银行
        };
        this.$emit('close');
      }
    }
  }
</script>
<style>

</style>
